export const dashboard = <i className="fas fa-tachometer-alt"></i>;
export const transactions = <i className="fas fa-exchange-alt"></i>;
export const categories = <i className="fas fa-tags"></i>;
export const accounts = <i className="fas fa-wallet"></i>;
export const settings = <i className="fas fa-cogs"></i>;
export const logout = <i className="fas fa-sign-out-alt"></i>;
export const trend = <i className="fas fa-chart-line"></i>;
export const expenses = <i className="fas fa-money-bill-wave"></i>;
export const money = <i className="fas fa-dollar-sign"></i>;
export const freelance = <i className="fas fa-globe-americas"></i>;
export const stocks = <i className="fas fa-chart-area"></i>;
export const bitcoin = <i className="fab fa-bitcoin"></i>;
export const piggy = <i className="fas fa-piggy-bank"></i>;
export const yt = <i className="fab fa-youtube"></i>;
export const card = <i className="fab fa-cc-visa"></i>;
export const users = <i className="fas fa-user-friends"></i>;
export const dollar = <i className="fas fa-dollar-sign"></i>;
export const calendar = <i className="far fa-calendar-alt"></i>;
export const comment = <i className="fas fa-comment"></i>;
export const plus = <i className="fas fa-plus"></i>;
export const trash = <i className="fas fa-trash-alt"></i>;
export const signout = <i className="fas fa-sign-out-alt"></i>;
export const takeaway = <i className="fas fa-utensils"></i>;
export const clothing = <i className="fas fa-tshirt"></i>;
export const book = <i className="fas fa-book-open"></i>;
export const food = <i className="fas fa-utensils"></i>;
export const medical = <i className="fas fa-briefcase-medical"></i>;
export const tv = <i className="fas fa-tv"></i>;
export const circle = <i className="fas fa-circle"></i>;
export const rupee = <i className="fas fa-rupee-sign"></i>;
export const calender = <i className="fas fa-calendar"></i>;

export const update = <i className="fa-regular fa-pen-to-square"></i>;
